/**
 * Pre-compiled de messages for Drawer
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { closeTrigger: `Schublade schließen` };
